import { type InfiniteData } from '@tanstack/react-query';

import type {
  NotifyUser,
  TargetingUser,
} from 'hb-react/frontoffice/components/NotifyPeopleModal/types';
import { fullName } from 'helpers/name';

export const formatUsers = (users: TargetingUser[] | null): NotifyUser[] => {
  if (!users) {
    return [];
  }

  return users.map((user) => ({
    id: user.id,
    name: fullName(user),
    avatar: user.photo_thumb_url,
    isRecommended: Boolean(user.suggested),
  }));
};

export const markCheckboxesNotCheckedAsUndefined = (query) =>
  Object.entries(query).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value === false ? undefined : value,
    }),
    {},
  );

interface UsersTargetingData {
  users: NotifyUser[];
  userIds: number[];
  count: number;
}

export const flattenPages = (
  data: InfiniteData<UsersTargetingData> | undefined,
) => {
  const pages = data?.pages || [];
  const count = pages?.[0]?.count || 0;
  let users: UsersTargetingData['users'] = [];
  let userIds: UsersTargetingData['userIds'] = [];

  pages.forEach((page) => {
    users = users.concat(page.users);
    userIds = userIds.concat(page.userIds);
  });

  return { users, userIds, count };
};
